import { App, type URLOpenListenerEvent } from '@capacitor/app'

import { RoutePath } from '@/RoutePath'

import { isNativePlatform } from './platform'

export const NATIVE_RETURN_PATH = '/native-return'

const APP_PATH_PREFIXES = [
  '/my-area',
  '/payment',
  '/receipt-upload',
  '/office',
  '/office-scan-orders',
  '/office-pickup-orders',
  '/office-scan-me',
  '/login',
  '/welcome',
  '/forgot-password',
]

export function pathFromAppUrl(url: string): string | null {
  try {
    const parsed = new URL(url)
    if (parsed.protocol === 'com.shiptanbul.app:') {
      const path = parsed.pathname || parsed.host || '/'
      return `${path.startsWith('/') ? path : `/${path}`}${parsed.search}${parsed.hash}`
    }
    if (parsed.pathname === NATIVE_RETURN_PATH || parsed.pathname.startsWith(`${NATIVE_RETURN_PATH}/`)) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }
    if (APP_PATH_PREFIXES.some(prefix => parsed.pathname === prefix || parsed.pathname.startsWith(`${prefix}/`))) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }
    return null
  } catch {
    return null
  }
}

export function clientPathAfterPaymentReturn(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const pkgId = params.get('pkgId')
  const status = params.get('status')
  if (pkgId && status === 'paid') {
    return `${RoutePath.ClientPkg}?paidPkgId=${encodeURIComponent(pkgId)}`
  }
  if (pkgId) {
    return `${RoutePath.ClientPkg}?pkgId=${encodeURIComponent(pkgId)}`
  }
  return RoutePath.ClientPkg
}

export async function consumeLaunchUrl(): Promise<string | null> {
  if (!isNativePlatform()) return null
  try {
    const launch = await App.getLaunchUrl()
    if (!launch?.url) return null
    return pathFromAppUrl(launch.url)
  } catch {
    return null
  }
}

export function listenForAppUrlOpen(onOpen: (path: string) => void): () => void {
  if (!isNativePlatform()) return () => undefined

  const handle = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const path = pathFromAppUrl(event.url)
    if (path) onOpen(path)
  })

  return () => {
    void handle.then(listener => listener.remove())
  }
}
